import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode disabled to prevent duplicate API calls in development
  // Re-enable before production: <React.StrictMode><App /></React.StrictMode>
  <App />
);
